export const OfflineViewControl = ({ children }) => {
  return process.env.REACT_APP_ENV === "localSetup" ? children : null;
};
